import { sendEvent } from '@utils/core/track';
import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import useAnchor from 'hooks/useAnchor';
import React, { FC, useEffect, useRef, useState } from 'react';
import { Swiper } from 'swiper/types';
import styles from './styles.scss';


const SubjectSection: FC = () => {
	const swiperRef = useRef<any>(null);
	const countryRef = useRef<any>(null);
	const [activeIndex, setActiveIndex] = useState(0);
	const { width } = useResizeObserver()
	const { transData, local, list } = useTranslation('oneOnOne.subject')

	const ListRenderTitle = list.map((item, index) => {
		return (
			<div
				key={index}
				className={classnames(styles['title-item'], activeIndex === item.id ? styles['active'] : '')}
				onClick={() => {
					setActiveIndex(item.id)
					sendEvent({ eventId: 'ACW_1on1_countrylevel', eventParam: { country: item.country } })
				}}
			>
				<img loading='lazy' src={item.countryIcon} alt="" />
			</div>
		)
	})

	const ListRender = list.map((item, index) => {

		return (
			<div
				key={index}
				className={classnames(styles['li-item'], styles['li-item-' + item.id])}
			>
				<img
					src={item.img} alt="" />
			</div>
		)
	})

	useAnchor()

	useEffect(() => {
		if (swiperRef.current) {
			swiperRef.current.slideTo(activeIndex, 0, false);
		}

	}, [activeIndex])

	return (
		<section className={styles['ac-subject']} id="subject">
			<div className={styles['ac-subject-container']}>
				<img className={styles['ac-subject-img-1']} src={(width >= 1192) ? 'https://web-data.zmlearn.com/image/enMUh57hn2axY2qGAavCXj/img_p4_left%402x.png' : 'https://web-data.zmlearn.com/image/rYuwke5npwdpBHT7MgKgT8/img_P4_left%402x.png'} alt="" />
				<img className={styles['ac-subject-img-2']} src="https://web-data.zmlearn.com/image/pV5MTMrjym1uaDmoaiAoJh/img_p4_right%402x.png" alt="" />
				{(width >= 768 && width < 1192) && <img className={styles['ac-subject-img-3']} src="https://web-data.zmlearn.com/image/C6YAmHqvyE52RN79MMggv/img_p3_right%402x.png" alt="" />}
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['country-wrap']} ref={countryRef}>
					<div className={classnames(styles['ac-subject-country'], 'ac-subject-country')}
					>{ListRenderTitle}</div>
				</div>
				<AcSwipe className={classnames(styles['ac-subject-banner'], 'ac-subject-banner')}
					loop={true}
					spaceBetween={32}
					pagination={width >= 768 ? {
						clickable: true,
					} : true}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					onSwiper={(swiper: Swiper) => {
						swiperRef.current = swiper;
					}}
					slidesPerView={1}
					onSlideChange={(swiper: any) => {
						if (countryRef.current.scrollLeft <= 0) {
							countryRef.current.scrollLeft = 0
						}
						if (swiper.activeIndex > 5) {
							countryRef.current.scrollLeft += ((width < 768 ? 650 : 1192) / swiper.activeIndex)
						}
						if (swiper.activeIndex < 5) {
							countryRef.current.scrollLeft -= ((width < 768 ? 650 : 1192) / swiper.activeIndex)
						}
						if (swiper.activeIndex > list.length) {
							setActiveIndex(1)
							countryRef.current.scrollLeft = 0
						} else {
							setActiveIndex(swiper.activeIndex)
						}
					}}
				>{ListRender}</AcSwipe>
			</div>
		</section >
	);
}

export default SubjectSection
